import React, { useEffect } from 'react';
import Hero from '../../components/sections/Hero';
import Overview from '../../components/sections/Overview';
import Services from '../../components/sections/Services';
import Process from '../../components/sections/Process';
import Technologies from '../../components/sections/Technologies';
import Gallery from '../../components/sections/Gallery';
import Cta from '../../components/sections/Cta';
import { setupScrollAnimations } from '../../utils/animations';
import { biPageData } from '../../data/biPageData';

const BiPage = () => {
  useEffect(() => {
    const observer = setupScrollAnimations();
    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <Hero
        variant="biHero"
        title={biPageData.hero.title}
        description={biPageData.hero.description}
      />
      <Overview data={biPageData.overview} />
      <Services data={biPageData.services} />
      <Process data={biPageData.process} />
      <Technologies data={biPageData.technologies} />
      <Gallery data={biPageData.gallery} />
      <Cta data={biPageData.cta} />
    </div>
  );
};

export default BiPage;
